<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
   
     
    </avue-crud>
      </div>
     
    </div>
  </template>
    <script>
  
  import { getHealthAlarmPage} from '@/api/nursingHome/healthData.js';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        healthVisitRecordFormVisible:false,
        formRow:{},
       data:[],
       formTitle:'新增',
       formModel:"add",
       option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '姓名',
            prop: 'elderlyName',
          },
          {
            label: '手机号',
            prop: 'phone',
          },
          {
            label: '报警名称',
            prop: 'alarmName',
          },
          {
            label: '发生时间',
            prop: 'alarmTime',
          },
          {
            label: '发生位置',
            prop: 'address',
          },
         
         
         
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchForm:{}
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      addRecord(row){
        this.formTitle ="新增"
        this.formModel ="add"
        this.healthVisitRecordFormVisible =true
      },
  
      editRecord(row){
        this.formTitle ="编辑"
        this.formModel ="edit"
        this.healthVisitRecordFormVisible =true
      },
      deleteRecord(row){
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          removeInspectRecord(id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.onLoad();
          });
        });
      },
       initData() {
        
        this.searchForm.nursinghomeId =this.row.nursinghomeId
      this.searchForm.elderlyId = this.row.id
      },
      onLoad(){
      getHealthAlarmPage(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.searchForm
        )
      )
        .then(({ data }) => {
          this.data =data.records
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
    
    },
  };
  </script>
    <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
    